import { AnyID, Item, LinkedItem, Partition, SceneObjects } from '@types'
import { Quaternion } from 'three'
import decomposeMatrix from './decomposeMatrix'

export function calculateDeltasBetweenSelectedItems(
  selectedItems: Set<AnyID>,
  items: Map<string, SceneObjects>,
): Map<
  string,
  Array<{ targetId: AnyID; targetRot: Quaternion; deltaX: number; deltaY: number; deltaZ: number }>
> {
  const deltas = new Map<
    string,
    Array<{
      targetId: AnyID
      targetRot: Quaternion
      deltaX: number
      deltaY: number
      deltaZ: number
    }>
  >()
  const selectedArray = Array.from(selectedItems)

  for (let i = 0; i < selectedArray.length; i++) {
    const id1 = selectedArray[i]
    const item1 = items.get(id1) as Item | Partition | LinkedItem

    if (!item1) continue

    const itemDeltas = []

    for (let j = 0; j < selectedArray.length; j++) {
      if (i === j) continue

      const id2 = selectedArray[j]
      const item2 = items.get(id2) as Item | Partition | LinkedItem

      if (!item2) continue

      const { position: position1 } = decomposeMatrix(item1.matrix)
      const { position: position2, rotation: rotation2 } = decomposeMatrix(item2.matrix)
      const deltaX = position2.x - position1.x
      const deltaY = position2.y - position1.y
      const deltaZ = position2.z - position1.z

      itemDeltas.push({ targetId: id2, targetRot: rotation2, deltaX, deltaY, deltaZ })
    }
    deltas.set(id1, itemDeltas)
  }
  return deltas
}
